import { createSlice } from '@reduxjs/toolkit';
import storage from 'local-storage-fallback';

export const INITIAL_SEARCH_PARAMS = { page: 1, pageSize: 10, sortBy: [], search: [] };

const updateSearchParams = ({ state, action, prop, resetPage = false }) => {
    const { payload } = action;
    const newSearchParams = JSON.parse(state.value);
    newSearchParams[prop] = payload; //  Array.isArray(payload) ? '' :
    if (resetPage) newSearchParams.page = 1;
    state.value = JSON.stringify(newSearchParams);
    storage.setItem('searchParamsAffiliatePrev', state.value);
};

export const SearchParamsSlice = createSlice({
    name: 'searchParamsAffiliatePrev',
    initialState: {
        value: JSON.stringify(INITIAL_SEARCH_PARAMS), //storage.getItem('searchParamsAffiliatePrev') || JSON.stringify(INITIAL_SEARCH_PARAMS),
    },
    reducers: {
        pageChanged: (state, action) => {
            console.log('Page Changed Action:', action.payload);
            updateSearchParams({ state, action, prop: 'page' });
        },
        filtersChanged: (state, action, resetPage = false) => {
            updateSearchParams({ state, action, prop: 'search', resetPage });
        },
        pageSizeChanged: (state, action, resetPage = false) => {
            updateSearchParams({ state, action, prop: 'pageSize', resetPage });
        },
        sortByChanged: (state, action, resetPage = false) => {
            updateSearchParams({ state, action, prop: 'sortBy', resetPage });
        },
        resetSearchParams: (state) => {
            updateSearchParams({ state, action: { type: 'searchParamsAffiliatePrev/pageChanged', payload: 1 }, prop: 'page' });
            updateSearchParams({ state, action: { type: 'searchParamsAffiliatePrev/filtersChanged', payload: [] }, prop: 'search' });
            updateSearchParams({ state, action: { type: 'searchParamsAffiliatePrev/sortByChanged', payload: [] }, prop: 'sortBy' });
        },
    },
});

// Action creators are generated for each case reducer function
export const { pageChanged, filtersChanged, pageSizeChanged, sortByChanged, resetSearchParams } = SearchParamsSlice.actions;

export default SearchParamsSlice.reducer;
